import { configureStore } from "@reduxjs/toolkit";
import UserReducer from "./features/userSlice";
import { AuthApi } from "./api/user/AuthApi";
import { ProfileTestApi } from "./api/ProfileTest/ProfileTestApi";
import { BookingApi } from "./api/Bookings/BookingApi";
import { PatientsApi } from "./api/Patients/PatientsApi";
import { DashboardApi } from "./api/dashboard/DashboardApi";
import { TestApi } from "./api/Test/TestApi";
import { BannerApi } from "./api/Banner/BannerApi";
import { AdminApi } from "./api/Admin/AdminApi";
import { TestimonialApi } from "./api/Testimonial/TestimonialApi";
import { EnquiryApi } from "./api/Enquiry/EnquiryApi";
import { FaqApi } from "./api/FAQ/FaqApi";
import { IssuesApi } from "./api/Issues/IssuesApi";
import { BillsAndReportsApi } from "./api/BillsAndReports/BillsAndReports";
import { CategoryApi } from "./api/FAQ_Category/CategoryApi";
import { NotificationsApi } from "./api/Notifications/NotificationsApi";
import { TeamApi } from "./api/Team/TeamApi";
import { PrescriptionApi } from "./api/Prescription/PrescriptionApi";
import { BranchesApi } from "./api/Branches/BranchesApi";
import { SidebarActivityApi } from "./api/SidebarActivity/SidebarActivityApi";
import { CareerApi } from "./api/Career/CareerApi";
import { BlogApi } from "./api/Blogs/BlogApi";
import { LoggerApi } from "./api/Logger/LoggerApi";
import { walletApi } from "./api/Wallet/WalletApi";
import { ServicePageApi } from "./api/ServicePage/ServicePageApi";


export const store = configureStore({
  reducer: {
    User: UserReducer,
    [AuthApi.reducerPath]: AuthApi.reducer,
    [ProfileTestApi.reducerPath]: ProfileTestApi.reducer,
    [TestApi.reducerPath]: TestApi.reducer,
    [BookingApi.reducerPath]: BookingApi.reducer,
    [PatientsApi.reducerPath]: PatientsApi.reducer,
    [DashboardApi.reducerPath]: DashboardApi.reducer,
    [BannerApi.reducerPath]: BannerApi.reducer,
    [AdminApi.reducerPath]: AdminApi.reducer,
    [TestimonialApi.reducerPath]: TestimonialApi.reducer,
    [EnquiryApi.reducerPath]: EnquiryApi.reducer,
    [FaqApi.reducerPath]: FaqApi.reducer,
    [IssuesApi.reducerPath]: IssuesApi.reducer,
    [CategoryApi.reducerPath]: CategoryApi.reducer,
    [BillsAndReportsApi.reducerPath]: BillsAndReportsApi.reducer,
    [NotificationsApi.reducerPath]: NotificationsApi.reducer,
    [TeamApi.reducerPath]: TeamApi.reducer,
    [PrescriptionApi.reducerPath]: PrescriptionApi.reducer,
    [BranchesApi.reducerPath]: BranchesApi.reducer,
    [SidebarActivityApi.reducerPath]: SidebarActivityApi.reducer,
    [CareerApi.reducerPath]: CareerApi.reducer,
    [BlogApi.reducerPath]: BlogApi.reducer,
    [LoggerApi.reducerPath]: LoggerApi.reducer,
    [walletApi.reducerPath]: walletApi.reducer,
    [ServicePageApi.reducerPath]: ServicePageApi.reducer,

  },
  devTools: process.env.NODE_ENV === "development",
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat([
      AuthApi.middleware,
      ProfileTestApi.middleware,
      TestApi.middleware,
      BookingApi.middleware,
      PatientsApi.middleware,
      DashboardApi.middleware,
      BannerApi.middleware,
      AdminApi.middleware,
      TestimonialApi.middleware,
      EnquiryApi.middleware,
      FaqApi.middleware,
      IssuesApi.middleware,
      CategoryApi.middleware,
      BillsAndReportsApi.middleware,
      NotificationsApi.middleware,
      TeamApi.middleware,
      PrescriptionApi.middleware,
      BranchesApi.middleware,
      SidebarActivityApi.middleware,
      CareerApi.middleware,
      BlogApi.middleware,
      LoggerApi.middleware,
      walletApi.middleware,
      ServicePageApi.middleware,

    ]),
});
